import React from "react";
import _ from "lodash";
import { Form, Col } from "react-bootstrap";
import { Select, MenuItem } from "@material-ui/core";
import { CONTENT_FINDER } from "../../constants/ContentFinder";
import "../../styles/media-search.scss";
import "../../styles/contentFinder.scss";

const ContentFinderRecordType = ({
  value,
  options,
  onChange,
}) => {
  return (
    <Form.Group
      className="m-0 p-0"
      as={Col}
      controlId="recordType"
    >
      <Form.Label className="media-request-formLabel">
        {CONTENT_FINDER.recordTypeFormLabel}
      </Form.Label>

      <Form.Control
        as={Select}
        disableUnderline={true}
        displayEmpty
        classes={{
          disabled: "formSelectDisabled",
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        value={value}
        onChange={(e) =>
          onChange(e.target.value)
        }
        className={"formInputSelect"}
      >
        <MenuItem
          className="dropdownSelect"
          value=""
        >
          -----
        </MenuItem>

        {_.map(options, (item, index) => (
          <MenuItem
            className="dropdownSelect"
            key={index}
            value={_.get(item, "value")}
          >
            {_.get(item, "label")}
          </MenuItem>
        ))}
      </Form.Control>
    </Form.Group>
  );
};

export default ContentFinderRecordType;
